var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeVolume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_1572_80519)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1562 28L39.6642 34.3112L39.6621 34.3152C39.2063 35.1456 38.6634 35.9215 38.0445 36.6306C37.9745 36.7108 37.9036 36.7901 37.8316 36.8686C37.1965 37.5615 36.4868 38.1863 35.7134 38.731L35.7087 38.7343C34.9343 39.2792 34.1058 39.7369 33.2383 40.1011C33.1402 40.1424 33.0416 40.1824 32.9425 40.2212C32.0678 40.5637 31.1561 40.8125 30.2225 40.9613C29.2827 41.1112 28.3355 41.1574 27.397 41.103C26.3541 41.0426 25.3219 40.8578 24.3227 40.5527C23.4247 40.2784 22.5533 39.9069 21.7246 39.4411L21.7219 39.4396L21.7207 39.4389C20.8958 38.9748 20.1255 38.424 19.4223 37.7971C18.8462 37.2835 18.315 36.7188 17.8359 36.1089C17.3567 35.4991 16.9337 34.8494 16.5709 34.1681C16.1493 33.3762 15.8092 32.5415 15.5568 31.6767L15.5561 31.6744C15.2906 30.7641 15.1255 29.831 15.0616 28.8914C14.9861 27.7828 15.0514 26.6653 15.2589 25.5659C15.4664 24.4665 15.8129 23.4021 16.2872 22.3972C16.6896 21.5449 17.1839 20.7355 17.7635 19.984C18.3179 19.2653 18.9438 18.6085 19.6296 18.0224C20.4509 17.3205 21.3585 16.7203 22.3332 16.2377C23.3079 15.7551 24.3355 15.3972 25.3917 15.1696C26.3131 14.971 27.2564 14.8716 28.2053 14.8751L28.1562 28Z",
    fill: "#1D1B18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6634 31.8675C40.031 31.1956 40.3234 30.4884 40.5375 29.7589C40.8374 28.7365 40.9834 27.6702 40.9666 26.5956C40.9378 24.7544 40.4321 22.9525 39.4992 21.3674C38.5663 19.7824 37.2385 18.469 35.6466 17.5566C34.7176 17.0242 33.7173 16.639 32.6811 16.4106C31.9418 16.2476 31.1842 16.1644 30.4211 16.1644V26.7621L39.6634 31.8675Z",
    fill: "#1D1B18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1572_80519",
    x1: 0,
    y1: 28.002,
    x2: 56,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeVolume);
export default __webpack_public_path__ + "static/media/Home_Volume.8b4db8ffeaa67977f14b4484dbfe6208.svg";
export { ForwardRef as ReactComponent };